<template>
  <component
    :is="wrapperComponent"
    class="c-card-item"
    :target="target"
    :href="href"
    :style="style"
    :to="to"
    @click="$emit('click', $event)"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <div
      v-if="icon !== ''"
      :style="iconStyle"
    >
      <c-icon
        v-if="iconType === 'internal'"
        :type="icon"
      />
      <notion-icon
        v-else
        :icon="icon"
      />
    </div>
    <div>
      <div
        v-if="!$slots.title"
        :style="{ whiteSpace: 'nowrap' }"
      >
        {{ title }}
      </div>
      <div v-else>
        <slot name="title" />
      </div>
      <div v-if="!!$slots.subTitle">
        <slot name="subTitle" />
      </div>
    </div>

    <div :style="{ marginLeft: 'auto' }">
      <slot name="right" />
    </div>
  </component>
</template>

<script>
import CCard from 'shared/components/CCard.vue';
import CIcon from 'shared/components/CIcon.vue';
import NotionIcon from 'shared/components/NotionIcon.vue';

export default {
  name: 'CCardItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: [String, Object],
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    to: {
      type: [String, Object],
      default: null,
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
    iconType: {
      type: String,
      default: 'internal',
    },
    alignTop: {
      type: Boolean,
      default: false,
    },
    showAsCard: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
    },
    roundedCorners: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  components: { CIcon, CCard, NotionIcon },
  data() {
    return { hover: false };
  },
  computed: {
    iconStyle() {
      const res = { marginRight: '1rem' };
      if (this.alignTop) {
        res.marginTop = '.5rem';
      }

      return res;
    },
    wrapperComponent() {
      if (this.showAsCard) {
        return 'c-card';
      }
      if (this.to !== null) {
        return 'router-link';
      }
      if (this.href !== '') {
        return 'a';
      }

      return 'div';
    },
    style() {
      const middlewares = [
        this.resizer,
        this.inker,
        this.makeTextStyle,
        this.positioner,
        this.makePadding,
          this.makeClickable,
      ];
      let res = {
        display: 'flex',
        alignItems: 'center',
        background: 'transparent',
        border: 'none',
        textDecoration: 'none',
        padding: '0 1.4rem',
        outline: 'none',
        borderRadius: '.4rem',
        color: this.$colors.grey.darken4,
      };
      middlewares.forEach((m) => {
        res = m(res);
      });
      return res;
    },
  },
  methods: {
    makeTextStyle(style) {
      if (this.active) {
        return {
          ...style,
          fontWeight: 'bold',
        };
      }

      return style;
    },
    makePadding(style) {
      if (this.$slots.subTitle) {
        return {
          ...style,
          padding: '.6rem 1.4rem',
        };
      }

      return style;
    },
    makeClickable(style) {
      if (this.clickable) {
        if (this.hover) {
          return {
            ...style,
            background: this.$colors.grey.lighten5,
            cursor: 'pointer',
          };
        }
        return {
          ...style,
          cursor: 'pointer',
        };
      }

      return style;
    },
    positioner(style) {
      if (this.alignTop) {
        return {
          ...style,
          alignItems: 'flex-start',
        };
      }

      return style;
    },
    resizer(style) {
      if (this.size === 'large') {
        return {
          ...style,
          minHeight: '4.2rem',
        };
      }
      return {
        ...style,
        minHeight: '3.2rem',
      };
    },
    inker(style) {
      if (this.showAsCard) {
        return {
          ...style,
          background: 'white',
        };
      }
      return {
        ...style,
        background: 'transparent',
      };
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

</style>
